/* eslint-disable react/prop-types */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { BarLoader } from 'react-spinners';

import Swal from 'sweetalert2';

import { CSVLink } from 'react-csv';

import history from '~/services/history';

import api from '~/services/api';

import { store } from '~/store';

import {
  BoxUpload,
  BoxSendButton,
  BoxInstructions,
} from '~/pages/LinhasDeCuidado/style';

import { catchErros } from '~/pages/LinhasDeCuidado/messages';

import template_acidente_vascular_cerebral from '~/assets/templates/template-avc';
import template_cancer_de_prostata from '~/assets/templates/template-prostata';
import template_artropatia_de_quadril from '~/assets/templates/template-quadril';
import template_sindrome_coronariana_aguda from '~/assets/templates/template-sca';
import template_sepse_e_choque_septico from '~/assets/templates/template-sepse';
import template_mam from '~/assets/templates/template-sepse';
import { getIndicadorLC } from '~/pages/LinhasDeCuidado/careLinesInfo';

export default function BoxUploadReenviar({
  linhaDeCuidadoValue,
  periodoSelecionado,
  senha,
}) {
  const { token, cnes } = store.getState().auth;

  const [loadingFile, setLoadingFile] = useState(false);
  const [csvFile, setCsvFile] = useState(null);

  const [templateCsv, setTemplateCsv] = useState(
    template_acidente_vascular_cerebral
  );

  const templateFileName = `${getIndicadorLC(
    linhaDeCuidadoValue
  )}${cnes}${periodoSelecionado?.replace('/', '')}`;

  useEffect(() => {
    setTemplateCsv(
      (linhaDeCuidadoValue === 'acidente_vascular_cerebral' &&
        template_acidente_vascular_cerebral) ||
        (linhaDeCuidadoValue === 'artropatia_de_quadril' &&
          template_artropatia_de_quadril) ||
        (linhaDeCuidadoValue === 'cancer_de_prostata' &&
          template_cancer_de_prostata) ||
        (linhaDeCuidadoValue === 'sepse_e_choque_septico' &&
          template_sepse_e_choque_septico) ||
        (linhaDeCuidadoValue === 'sindrome_coronariana_aguda' &&
          template_sindrome_coronariana_aguda) ||
        (linhaDeCuidadoValue === 'cancer_de_mama' && template_mam)
    );
  }, [linhaDeCuidadoValue]);

  const enviarLinhaDeCuidado = async () => {
    const formData = new FormData();
    formData.append('arquivo', csvFile);
    formData.append('periodo', periodoSelecionado);
    formData.append('senha', senha);

    setLoadingFile(true);

    try {
      const response = await api.post(
        `indicadores-linhas-de-cuidado/${linhaDeCuidadoValue}`,
        formData,
        {
          headers: {
            Authorization: token,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      Swal.fire({
        title: 'Obrigado!',
        text: `${String(response.data.menssagem)}`,
        icon: 'success',
        confirmButtonColor: '#74a50a',
        confirmButtonText: 'Ok! Obrigado!',
      }).then(() => {
        window.location.reload();
      });

      setLoadingFile(false);
      setCsvFile(null);
    } catch (error) {
      if (error?.response?.data?.cause === 'invalid_care_line') {
        Swal.fire({
          title: 'Atenção',
          text: `${error?.response?.data?.error}`,
          icon: 'error',
          confirmButtonColor: '#74a50a',
        }).then(() => {
          window.location.reload();
        });

        return;
      }

      const { code } = error.response.data;
      if (error.response?.data?.fields?.length > 0) {
        let ext = error.response?.data?.fields.filter(
          x => x.parameter == 'extensao_arquivo'
        );
        let name = error.response?.data?.fields.filter(
          x => x.parameter == 'nome_arquivo'
        );
        let msg = '';
        if (ext?.length > 0) {
          msg += '<b>' + ext[0].exception + '</b></br>';
        }
        if (name?.length > 0) {
          msg += msg.length > 0 ? '</br>' : '';
          msg +=
            '<b>Nome do arquivo incorreto, formato aceito: (lc(3)|cnes(7)|periodo(6))</b></br>';
          name.forEach(r => {
            msg += r.exception + '</br>';
          });
        }
        Swal.fire({
          title: 'Atenção',
          width: '40%',
          html: `${msg}`,
          icon: 'error',
          confirmButtonColor: '#74a50a',
        });
        setLoadingFile(false);
      } else {
        Swal.fire({
          title: 'Atenção',
          text: ` ${error.response.data.error}`,
          icon: 'error',
          confirmButtonColor: '#74a50a',
        }).then(() => {
          if (code === '401') {
            window.location.reload();
            return;
          }

          history.push({
            pathname: `/relatorio-de-inconsistencias/${linhaDeCuidadoValue}`,
            state: {
              periodo: periodoSelecionado,
            },
          });
        });

        setLoadingFile(false);
        setCsvFile(null);
      }
    }
  };

  const handleCsvFile = e => {
    setCsvFile(e.target.files[0]);
  };

  useEffect(() => {
    if (csvFile) {
      enviarLinhaDeCuidado();
    }
  }, [csvFile]);

  return (
    <>
      <BoxUpload id="BoxUpload">
        <form id="fileUploadForm">
          <label htmlFor="fileUpload">
            <input
              type="file"
              accept=".csv"
              id="fileUpload"
              onChange={e => handleCsvFile(e)}
            />
          </label>
          {loadingFile ? (
            <div className="loadingFile">
              <BarLoader
                css={{ width: '200px' }}
                size={288}
                color="#74a50a"
                loading={loadingFile}
              />
              <span>Enviando, aguarde...</span>
            </div>
          ) : (
            <>
              <BoxSendButton>
                <button type="button">Enviar arquivo .csv</button>
              </BoxSendButton>
              <p id="fileSelected"> </p>
              <span className="fileUploadText">
                {csvFile != null ? (
                  <>
                    Arquivo selecionado: <br />
                    {csvFile.name}
                    <br />
                    <br />
                  </>
                ) : (
                  <>
                    Busque o arquivo para <br /> fazer upload.
                    <br />
                  </>
                )}
              </span>
            </>
          )}
        </form>
      </BoxUpload>

      <BoxInstructions>
        <span>Dúvidas sobre o padrão requerido?</span>
        <p>
          <CSVLink
            filename={`${templateFileName}.csv`}
            data={templateCsv}
            title="Baixe aqui o template do arquivo CSV com instruções."
          >
            Baixe aqui o template do arquivo
            <br /> CSV com instruções.
          </CSVLink>

          {/* <a
            href={templateCsv}
            target="_blank"
            rel="noreferrer noopener"
            title="Baixe aqui o template do arquivo CSV com instruções."
          >
            Baixe aqui o template do arquivo
            <br /> CSV com instruções.
          </a> */}
        </p>
      </BoxInstructions>
    </>
  );
}
